import initializeRecruitmentSourcesSuggesters from '../features/recruitment_sources_suggester';

window.Bizneo.recruitment_sources_suggester_controller = {
  initialize_recruitment_sources_suggesters() {
    initializeRecruitmentSourcesSuggesters();
  },
};
